// List of locations to show APR, unless the orgUnitId
// is provided on the list to ignore it.
export default {
    APR_LOCATIONS: ['mb'], // Manitoba
    APR_ORG_UNIT_IDS: [2164], // Brandon Chrysler
};
